import { render } from "./AdvocacyPillar.vue?vue&type=template&id=23d3dffd&scoped=true"
import script from "./AdvocacyPillar.vue?vue&type=script&lang=js"
export * from "./AdvocacyPillar.vue?vue&type=script&lang=js"

import "./AdvocacyPillar.vue?vue&type=style&index=0&id=23d3dffd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d3dffd"]])

export default __exports__